export default {
  CATEGORY_SELECT_PATH: 'categorySelect',

  RECIPE_SELECT_PATH: 'recipeSelect',

  PRODUCT_SELECT_PATH: 'productSelect',

  USER_SELECT_PATH: 'userSelect'
}